import extractDetailedQuestionnaireData from '../data_management/extractDetailedQuestionnaireData'
import insertDetailedQuestionnaireData from '../data_management/insertDetailedQuestionnaireData'
import extractSecretKey from '../data_management/extractSecretKey'
import changeQuestionnaireTitle from '../data_management/changeQuestionnaireTitle'
import changeQuestionnaireDescription from '../data_management/changeQuestionnaireDescription'
import changeQuestionnaireQuestionOrder from '../data_management/changeQuestionnaireQuestionOrder'
import replaceQuestionInQuestionnaire from '../data_management/replaceQuestionInQuestionnaire'
import removeQuestionFromQuestionnaire from '../data_management/removeQuestionFromQuestionnaire'
import addQuestionToQuestionnaire from '../data_management/addQuestionToQuestionnaire'

export default class {
  constructor(initialDataInteractor, dataService, coachGateway, editorGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.dataService = dataService;
    this.coachGateway = coachGateway;
    this.editorGateway = editorGateway;
  }

  loadQuestionnaire(questionnaireId, onLoad) {
    this.editorGateway.loadDetailedQuestionnaire(extractSecretKey(this.initialDataInteractor), questionnaireId, function (questionnaireData) {
      questionnaireData.price = parseFloat(questionnaireData.price);
      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaireData);
      onLoad();
    }.bind(this));
  }

  updateTitle(questionnaireId, newTitle, onSuccess, onFailure) {
    this.editorGateway.updateQuestionnaireTitle(extractSecretKey(this.initialDataInteractor), questionnaireId, {title: newTitle}, function () {
      this.onUpdateTitleSuccess(questionnaireId, newTitle, onSuccess);
    }.bind(this), function () {
      onFailure();
    })
  }

  onUpdateTitleSuccess(questionnaireId, newTitle, onSuccess) {
    changeQuestionnaireTitle(this.initialDataInteractor, questionnaireId, newTitle);
    onSuccess();
  }

  updateDescription(questionnaireId, newDescription, onSuccess, onFailure) {
    this.editorGateway.updateQuestionnaireDescription(extractSecretKey(this.initialDataInteractor), questionnaireId, {description: newDescription}, function () {
      changeQuestionnaireDescription(this.initialDataInteractor, questionnaireId, newDescription);
      onSuccess();
    }.bind(this), function () {
      onFailure();
    })
  }

  updateQuestionInQuestionnaire(data, onSuccess, onFailure) {
    this.editorGateway.updateQuestionInQuestionnaire(extractSecretKey(this.initialDataInteractor), {
      'questionnaire_id': data.questionnaireId,
      'question_data': data,
      'question_position': data.questionPosition
    }, function () {
      replaceQuestionInQuestionnaire(this.initialDataInteractor, data.questionnaireId, data.questionPosition, data);
      onSuccess();
    }.bind(this), function () {
      console.log('Failed to update question');
      onFailure();
    })
  }

  removeQuestionFromQuestionnaire(questionnaireId, questionPosition, onSuccess, onFailure) {
    this.editorGateway.removeQuestionFromQuestionnaire(extractSecretKey(this.initialDataInteractor), questionnaireId, questionPosition, function () {
      removeQuestionFromQuestionnaire(this.initialDataInteractor, questionnaireId, questionPosition);
      onSuccess();
    }.bind(this), onFailure)
  }

  createNewQuestion(questionnaireId, data, onSuccess, onFailure) {
    let questionData = {
      question: {
        content: data.content,
        question_type: data.type,
        analysis_preamble: '',
        ancestorId: null,
        range_info: {
          lower_bound: 0,
          lower_label: '',
          upper_bound: 100,
          upper_label: ''
        }
      }
    };

    this.editorGateway.createNewQuestion(extractSecretKey(this.initialDataInteractor), questionnaireId, questionData, function (newQuestion) {
      questionData.id = newQuestion.id;
      addQuestionToQuestionnaire(this.initialDataInteractor, questionnaireId, questionData);
      onSuccess(newQuestion);
    }.bind(this), function () {
      onFailure();
    })
  }

  repositionQuestion(questionnaireId, originalPosition, targetPosition, onSuccess, onFailure) {
    this.editorGateway.repositionQuestion(extractSecretKey(this.initialDataInteractor), questionnaireId, {
      original_position: originalPosition,
      requested_position: targetPosition
    }, function (data) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      questionnaire = this.reorderQuestions(questionnaire, data.reordered_question_indexes);
      this.insertSectionDataIntoQuestion(questionnaire.questions[ targetPosition ], data.section);
      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess(questionnaire);
    }.bind(this), function () {
      onFailure();
    })
  }

  addQuestionToSection(questionnaireId, questionIndex, sectionName, onSuccess, onFailure) {
    this.editorGateway.addQuestionToSection(extractSecretKey(this.initialDataInteractor), questionnaireId, questionIndex, sectionName, function (data) {
      this.onSectionsUpdated(questionnaireId, questionIndex, data, onSuccess)
    }.bind(this), onFailure);

  }

  moveSectionUp(questionnaireId, section, onSuccess, onFailure) {
    let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
    let sections = this.getOrderedSections(questionnaire);
    let original_position = sections.indexOf(section);
    sections.splice(original_position, 1);
    let new_position = original_position - 1;

    if (new_position >= 0) {
      sections.splice(original_position - 1, 0, section);
      this.rearrangeSections(questionnaireId, sections, onSuccess, onFailure)
    }
  }

  moveSectionDown(questionnaireId, sectionId, onSuccess, onFailure) {
    let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
    let sections = this.getOrderedSections(questionnaire);
    let original_position = sections.indexOf(sectionId);
    sections.splice(original_position + 2, 0, sectionId);
    sections.splice(original_position, 1);

    this.rearrangeSections(questionnaireId, sections, onSuccess, onFailure)
  }

  getOrderedSections(questionnaire) {
    let sections = questionnaire.questions.map(question => {
      if (question.section) {
        return question.section
      } else {
        return null
      }
    }).filter(id => id != null);
    return [ ...new Set(sections) ];
  }

  rearrangeSections(questionnaireId, newSectionIdOrder, onSuccess, onFailure) {
    this.editorGateway.reorderSections(extractSecretKey(this.initialDataInteractor), questionnaireId, newSectionIdOrder, function (data) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      questionnaire = this.reorderQuestions(questionnaire, data.reordered_question_indexes);
      onSuccess(questionnaire);
    }.bind(this), onFailure)
  }

  onSectionsUpdated(questionnaireId, questionIndex, receivedData, callback) {
    let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
    // console.log(questionnaire.questions);
    this.insertSectionDataIntoQuestion(questionnaire.questions[ questionIndex ], receivedData.section);
    questionnaire = this.reorderQuestions(questionnaire, receivedData.reordered_question_indexes);
    insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
    callback(questionnaire);
  }

  insertSectionDataIntoQuestion(question, sectionData) {
    if (sectionData) {
      question.section = sectionData.title;
    } else {
      question.section = null;
    }
  }

  reorderQuestions(questionnaire, reorderedQuestionIndexes) {
    let newQuestions = [];

    reorderedQuestionIndexes.forEach(old_index => newQuestions.push(questionnaire.questions[ old_index ]));
    questionnaire.questions = newQuestions;

    return questionnaire;
  }

  updateSectionTitle(questionnaireId, originalTitle, newTitle, onSuccess, onFailure) {
    this.editorGateway.updateSectionTitle(extractSecretKey(this.initialDataInteractor), questionnaireId, originalTitle, newTitle, function (data) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);

      let old_section = questionnaire.sections.find(section => section.title === originalTitle);
      old_section.title = data.new_title;

      questionnaire.questions.forEach(question => {
        if (question.section === originalTitle) {
          question.section = data.new_title
        }
      });

      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess(data);
    }.bind(this), onFailure)
  }

  updateSectionDescription(questionnaireId, sectionTitle, newDescription, onSuccess, onFailure) {
    this.editorGateway.updateSectionDescription(extractSecretKey(this.initialDataInteractor), questionnaireId, sectionTitle, newDescription, function (data) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      let section = questionnaire.sections.find(section => section.title === sectionTitle);
      section.description = data.description;

      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess(data.description);
    }.bind(this), onFailure)
  }

  tagSection(questionnaireId, sectionTitle, newTag, onSuccess, onFailure) {
    this.editorGateway.tagSection(extractSecretKey(this.initialDataInteractor), questionnaireId, sectionTitle, newTag, function (receivedTagName) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      let section = questionnaire.sections.find(section => section.title === sectionTitle);
      section.tags.push(receivedTagName);
      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess(receivedTagName);
    }.bind(this), onFailure)
  }

  untagSection(questionnaireId, sectionTitle, tagName, onSuccess, onFailure) {
    this.editorGateway.untagSection(extractSecretKey(this.initialDataInteractor), questionnaireId, sectionTitle, tagName, function (receivedTagName) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      let section = questionnaire.sections.find(section => section.title === sectionTitle);
      section.tags.splice(section.tags.indexOf(receivedTagName), 1);
      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess(receivedTagName);
    }.bind(this), onFailure)
  }

  getQuestionlessSections(questionnaire) {
    return questionnaire.sections.filter(section => {
      return !questionnaire.questions.find(question => question.section === section.title)
    })
  }

  createEmptySection(questionnaireId, sectionTitle, onSuccess, onFailure) {
    this.editorGateway.createEmptySection(extractSecretKey(this.initialDataInteractor), questionnaireId, sectionTitle, function (newSectionTitle) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      questionnaire.sections.push({
        title: newSectionTitle,
        tags: []
      });
      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess();
    }.bind(this), onFailure)
  }

  deleteSection(questionnaireId, sectionTitle, onSuccess, onFailure) {
    this.editorGateway.deleteSection(extractSecretKey(this.initialDataInteractor), questionnaireId, sectionTitle, function (reorderedQuestionIndexes) {
      let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
      questionnaire = this.reorderQuestions(questionnaire, reorderedQuestionIndexes);
      questionnaire.questions.forEach(question => {
        if (question.section === sectionTitle) {
          question.section = null;
        }
      });

      let section = questionnaire.sections.find(section => section.title === sectionTitle);
      questionnaire.sections.splice(questionnaire.sections.indexOf(section), 1);

      insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
      onSuccess();
    }.bind(this), onFailure)
  }

  updateEcommerceSettings(questionnaireId, newPrice, publiclyAvailable, newDescription) {
    return this.coachGateway.setQuestionnaireEcommerceSettings(extractSecretKey(this.initialDataInteractor), questionnaireId, newPrice, publiclyAvailable, newDescription)
      .then(data => {
        let questionnaire = extractDetailedQuestionnaireData(this.initialDataInteractor, questionnaireId);
        questionnaire.price = data.price;
        questionnaire.publiclyAvailable = data.publicly_available;
        insertDetailedQuestionnaireData(this.initialDataInteractor, questionnaire);
        return parseFloat(data.price);
      })
  }

  transferOwnership(questionnaire, person) {
    return this.coachGateway.updateQuestionnaire(this.dataService.secretKey, questionnaire.id, person.id)
      .then(() => {
        this.initialDataInteractor.data.questionnaires = this.initialDataInteractor.data.questionnaires
          .filter(q => q.id != questionnaire.id);
      });
  }
}